import { axiosInstance } from '../../axios'

export const userPhoneServices = {
  create: (requestModel: any) => {
    return axiosInstance.post('user-phones', requestModel)
  },
  update: (id: string, requestModel: any) => {
    return axiosInstance.put(`user-phones/${id}`, requestModel)
  },
  findAll: () => {
    return axiosInstance.get('user-phones')
  },
  findOne: (id: string) => {
    return axiosInstance.get(`user-phones/${id}`)
  },
  findByUserId: (id: string) => {
    return axiosInstance.get(`user-phones/findByUserId/${id}`)
  },
  remove: (id: string) => {
    return axiosInstance.delete(`user-phones/${id}`)
  },
}
